import React, { FC } from 'react';
import { CardContent, Card, Box, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

type ICardAlertContainer = {
  mainText?: string;
  severity: 'success' | 'error';
};

const CardAlertContainer: FC<ICardAlertContainer> = ({
  mainText,
  severity,
  children,
}) => {
  return (
    <Card
      sx={{
        bgcolor: severity === 'error' ? 'error.main' : 'success.main',
        borderRadius: '8px',
        shadow: '0 3px 6px 0 0',
        width: '80%',
        boxSizing: 'border-box',
      }}
    >
      <CardContent>
        <Box
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          {severity === 'error' ? (
            <WarningAmberOutlinedIcon sx={{ color: 'background.default' }} />
          ) : (
            <CheckCircleOutlineIcon sx={{ color: 'background.default' }} />
          )}
        </Box>
        <Typography
          sx={{
            color: 'background.default',
            textAlign: 'center',
            lineHeight: '28px',
            fontSize: '18px',
          }}
        >
          {mainText || children}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CardAlertContainer;
